import React, { FC } from 'react';

import { CorvalProject, CorvalProjectVersion } from '../../../../../types';
import { ProjectListItem }                     from './ProjectListItem';
import { Cell, Grid }                          from 'styled-css-grid';
import { useSystemSettings }                   from "@src/hooks/useSystemSettings";
import { ProjectService }                      from "@src/services";


interface Props {
    items: CorvalProject[],
}

const defaultProps: Props = {
    items: []
}

const ProjectList: FC<Props> = ( props ) => {

    const { filterProjectsByVisibility } = useSystemSettings();

    let projects = props.items;

    let hasProjects = ( projects.length > 0 );

    if( !hasProjects ) return null;

    const [ visibleProjects ] = filterProjectsByVisibility( projects );

    return (

        <>

            <Grid columns={ 1 } rowGap={ `30px` }>

                { visibleProjects.map( project => {
                    return (
                        <Cell key={ project.id }>
                            <ProjectListItem project={ project as CorvalProject }/>
                        </Cell>
                    )

                } ) }

            </Grid>

        </>
    );
};

ProjectList.defaultProps = defaultProps;

export { ProjectList }
